import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { ssApiService } from 'app/services/ss-api.service';
import { GlobalServices } from 'app/services/global.service';
import { CreditCardResponse } from 'app/models/ss-api/responses/credit.card.response';
import { UpdateCreditCardExpirationRequest } from 'app/models/ss-api/requests/update.credit.card.expiration.request';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

export interface IEditCreditCardDialogModel {
  CreditCard: CreditCardResponse;
}

@Component({
  selector: 'edit-credit-card-dialog',
  styleUrls: ['./edit-credit-card-dialog.component.css'],
  templateUrl: './edit-credit-card-dialog.component.html'
})
export class EditCreditCardDialogComponent {

  IsBusy: boolean = false;

  CreditCard: CreditCardResponse;

  ExpirationMonth: number;
  ExpirationYear: number;
  ZipCode: string;
  IsDefault: boolean;

  Year: number = new Date().getFullYear();
  YearRange: any[] = [];

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private api: ssApiService,
    private gb: GlobalServices) {

  }

  ngOnInit() {
    this.CreditCard = this.config.data.CreditCard;
    this.ExpirationMonth = this.CreditCard.ExpMonth;
    this.ExpirationYear = this.CreditCard.ExpYear;
    this.IsDefault = this.CreditCard.IsDefault;
    this.ZipCode = this.CreditCard.PostalCode;

    // SET UP YEAR RANGE FOR CREDIT CARD EXPIRATION DATE FIELD
    for (let i: number = 0; i < 15; i++) {
      this.YearRange.push(this.Year + i);
    }
  }

  IsFormDisabled() {
    return false;
  }

  Substring(year) {
    return year.toString().substr(2);
  }

  confirm() {
    this.IsBusy = true;
    let request: UpdateCreditCardExpirationRequest = {
      CreditCardID: this.CreditCard.ID,
      ExpMonth: this.ExpirationMonth,
      ExpYear: this.ExpirationYear,
      Zipcode: this.ZipCode
    };

    // validate
    if (!this.isValidExpiration()) {

      this.IsBusy = false;

      // show confirmation
      Swal.fire({
        title: "Validation Error",
        text: "The expiration date is invalid.",
        icon: 'error',
        showCancelButton: false,
        showConfirmButton: true,
      }).then(() => { }, () => { }); // keep this line to prevent promise error;

      return; // error
    }

    let disposable = this.api.CreditCardUpdateExpiration(request).subscribe(response => {
      this.IsBusy = false;

      if (response.Result) {
        Swal.fire({
          icon: 'success',
          title: 'Credit Card Updated',
          timer: 1500,
          showConfirmButton: false
        }).then(() => { this.close(true, this.IsDefault); }, () => { this.close(false, false); });
      } else {

       
        var title = "Error";
        var message = "Error updating credit card";

        if (response.Data.includes("AVS")) {
          title = "Zip Code Error";
          message = "Wrong Zip Code for this card.";
        }
        else if (response.Data.includes("CVC")) {
          title = "CVC Error";
          message = "Wrong CVC Security code for this card.";
        }


        Swal.fire({
          icon: 'error',
          title: title,
          text: response.Message,
          showConfirmButton: false
        }).then(() => { }, () => { });
      }

      disposable.unsubscribe();
    });
  }

  close(isUpdated = false, setAsDefault = false) {
    this.ref.close({ isUpdated, setAsDefault });
  }

  isValidExpiration() {
    if (moment(this.ExpirationMonth + '/' + this.ExpirationYear, 'MM/YYYY').isSameOrAfter(moment(moment().format('MM/YYYY'), 'MM/YYYY'))) {
      return true;
    } else {
      return false;
    }
  }

}
